import { useMemo } from "react";
import { BADGE_IDS, BadgeId } from "src/components/GoBadge";

interface UseItemTypesProps {
    itemDiscontinued?: boolean;
    isCore?: boolean;
    isKvi?: boolean;
}

const useItemTypes = (data: UseItemTypesProps): BadgeId[] => {
    const badgeIds = useMemo(() => {
        const badges: BadgeId[] = [];

        if (data.isKvi) {
            badges.push(BADGE_IDS.KVI);
        }

        if (data.isCore) {
            badges.push(BADGE_IDS.CORE);
        }

        if (data.itemDiscontinued) {
            badges.push(BADGE_IDS.DISCONTINUED);
        }

        return badges;
    }, [data]);

    return badgeIds;
};

export default useItemTypes;
